import {Component, EventEmitter, input, Output} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {EpgIconButtonComponent} from '@epg-apps/ui-icon-button';

/**
 * User menu fullscreen UI
 * This component an user menu overlay in fullscreen mode.
 * This component containts other three optionals components inside: <epg-user-profile-info> , <epg-language-selector>, <epg-user-menu-selection>.
 *
 *
 * * * @example
 * * * * ```typescript
 * // In your component:
 *
  import { UiEpgButtonDirective, UiEpgButtonIconDirective } from '@epg-apps/ui-button';
  import {CdkAccordionModule} from '@angular/cdk/accordion';
  import { EpgUserMenuNavigationFullscreenComponent } from '@epg-apps/epg-user-menu-navigation-fullscreen';
  import {EpgUserProfileInfoComponent} from '@epg-apps/epg-user-profile-info';
  import {EpgLanguageSelectorComponent} from '@epg-apps/epg-language-selector';
  import {EpgUserMenuSelectionComponent} from '@epg-apps/epg-user-menu-selection';
 *
* // In your html:
 *    <epg-user-menu-navigation-fullscreen>
          <epg-user-profile-info>
            <h2>Smith, Robert</h2>
            <p class="email">robert.smithpartena.be</p>
          </epg-user-profile-info>
          <epg-language-selector>
            <cdk-accordion>
              <cdk-accordion-item #accordionItem="cdkAccordionItem">
                <button
                  epg-button
                  epg-button-icon
                  [shape]="'text'"
                  class="button-option"
                  (click)="accordionItem.toggle()"
                  tabindex="0"
                  id="accordion-header-0"
                  [attr.aria-expanded]="accordionItem.expanded"
                  aria-controls="accordion-body-0"
                >
                  <span>English</span>
                  <span class="fas fa-chevron-down"></span>
                </button>
                @if(accordionItem.expanded) {
                <div
                  class="language-selector"
                  [style.display]="accordionItem.expanded ? '' : 'none'"
                  id="accordion-body-0"
                  aria-labelledby="accordion-header-0"
                >
                  <button epg-button [shape]="'text'" class="language-item">
                    Test
                  </button>
                  <button epg-button [shape]="'text'" class="language-item">
                    Test
                  </button>
                  <button epg-button [shape]="'text'" class="language-item">
                    Test
                  </button>
                </div>
                }
              </cdk-accordion-item>
            </cdk-accordion>
          </epg-language-selector>
          <epg-user-menu-selection>
              <button epg-button [shape]="'text'" epg-button-icon class="button-option">
                <span class="icon fa-pencil far"></span>
                <span>Update profile</span>
              </button>

              <button epg-button [shape]="'text'" epg-button-icon class="button-option">
                <span class="icon fa-gear far"></span>
                <span>Parameters</span>
              </button>

              <div class="card-footer">
                <button epg-button [shape]="'text'" epg-button-icon class="button-option">
                    <span class="icon far fa-right-from-bracket"></span>
                    <span>Logout</span>
                  </button>
              </div>
          </epg-user-menu-selection>
        </epg-user-menu-navigation-fullscreen>
 */

@Component({
  selector: 'epg-user-menu-navigation-fullscreen',
  imports: [MatIconModule, EpgIconButtonComponent],
  templateUrl: './epg-user-menu-navigation-fullscreen.component.html',
  styleUrl: './epg-user-menu-navigation-fullscreen.component.scss',
})
export class EpgUserMenuNavigationFullscreenComponent {
  isOpen = input<boolean>(false);
  @Output() onToggleOverlayClick = new EventEmitter<boolean>();

  toggleOverlay() {
    console.log('on child click', this.isOpen());
    this.onToggleOverlayClick.emit(!this.isOpen());
  }
}
